import translationFR from "@/assets/locales/fr/translations.json";
import translationEN from "@/assets/locales/en/translations.json";

export enum Locales {
  FR = "FR",
  EN = "EN",
}

export const LocaleTranslations = {
  [Locales.FR]: {
    translation: translationFR,
  },
  [Locales.EN]: {
    translation: translationEN,
  },
};

export const isLanguageSupported = (language: string): boolean => {
  return Object.values(Locales).includes(language.toUpperCase() as Locales);
};
